import React from 'react';
import { Drawer, List, MenuItem, Typography, Button, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { loginUserWithRedirect, logout } from 'auth/authUtils';
import { authenticatingUser } from 'redux/actions/auth';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
    paperRoot: {
        backgroundColor: '#112',
        color: 'white',
        width: '250px',
    },
    menuItemRootNoHover: {
        '&:hover': {
            cursor: 'auto',
        },
        lineHeight: 2,
    },
    menuItemRoot: {
        lineHeight: 2,
    },
});

const MenuDrawer = (props) => {
    const { open, onClose } = props;
    const auth = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const userAuthenticating = useSelector((state) => state.user.authenticatingUser);
    const history = useHistory();
    const classes = useStyles();
    
    const login = () => {
        dispatch(authenticatingUser());
        loginUserWithRedirect();
    };

    const navigate = (route) => {
        history.push(route)
        onClose()
    }

    return (
        <Drawer classes={{ paper: classes.paperRoot }} variant='temporary' anchor='right' open={open} onClose={onClose}>
            <List>
                <MenuItem onClick={() => navigate('/')}>
                    <Typography component='div' color='inherit'>
                        Home
                    </Typography>
                </MenuItem>
                {auth.authenticated && (
                    <>
                        <MenuItem classes={{ root: classes.menuItemRoot }} onClick={() => navigate('/mydashboards')}>
                            <Typography component='div' color='inherit'>
                                My Dashboards
                            </Typography>
                        </MenuItem>
                        <MenuItem classes={{ root: classes.menuItemRoot }} onClick={() => navigate('/search')}>
                            <Typography component='div' color='inherit'>
                                Search Dashboards
                            </Typography>
                        </MenuItem>
                    </>
                )}
                <MenuItem disableRipple classes={{ root: classes.menuItemRootNoHover }}>
                    {userAuthenticating && <div>Logging in...</div>}
                    {!userAuthenticating && auth.authenticated && (
                        <Button variant='contained' onClick={logout}>
                            Log Out
                        </Button>
                    )}
                    {!userAuthenticating && !auth.authenticated && (
                        <Button variant='contained' onClick={login}>
                            Log In
                        </Button>
                    )}
                </MenuItem>
            </List>
        </Drawer>
    );
};

export default MenuDrawer;
